import { useLayoutEffect, useRef, useState } from "react";
import { AuthService, IUserInfo, UserClaims } from "shared/mechanics/auth";

import styles from './UserComponent.module.scss';

const SignInButton = () => {
	return <a href={`/auth/signin?redirectUrl=${encodeURI(document.location.pathname + document.location.search)}`} className={styles.singin}>Войти</a>
}

function signOut() {
	AuthService.signOut();
	window.location.reload();
}

const User = (props: { userInfo: IUserInfo }) => {
	const [isMenuOpened, setIsMenuOpened] = useState(false);
	const userRef = useRef<HTMLDivElement>(null);

	useLayoutEffect(() => {
		if (!isMenuOpened)
			return;
		if (!userRef.current)
			return;

		const eventHandler = (ev: MouseEvent): void => {
			if (!userRef.current!.contains(ev.target as Node))
				setIsMenuOpened(false);
		};

		window.addEventListener('click', eventHandler);

		return () => {
			window.removeEventListener('click', eventHandler);
		}
	}, [isMenuOpened, userRef.current]);

	return (
		<div ref={userRef}>
			<i className={`fa fa-user ${styles.user}`} title={props.userInfo.displayName} onClick={() => setIsMenuOpened(!isMenuOpened)}></i>
			{
				isMenuOpened
					? (
						<div className={styles.user_popup}>
							<ul className={styles.user_popup_actions}>
								<li onClick={() => signOut()}>Выход</li>
							</ul>
						</div>
					)
					: null
			}
		</div>
	);
}

export const UserComponent = () => {
	const userInfo = AuthService.resolveUserInfo();

	return (
		<div className={`user ${styles.container}`}>
			{
				userInfo
					? <User userInfo={userInfo} />
					: <SignInButton />
			}
		</div>
	);
}